import {
  Box,
  Container,
  List,
  ListDivider,
  ListItem,
  ListItemContent,
  Stack,
  Typography,
} from "@mui/joy";
import { doc, setDoc } from "firebase/firestore";
import * as React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import HeaderBackButton from "../components/HeaderBackButton";
import {
  convertTimestamp,
  convertTimestampTime,
} from "../components/HistoryItem";
import { db } from "../config/firebase";
import {
  CryptoCurrencyFormat,
  CurrencyFormat,
} from "../config/services";
import { usdToCoin } from "../config/priceCache";

export default function TransactinDetails() {
  const userinfo = useSelector((state) => state.useInfos);
  const ad = useSelector((state) => state.walletInfos);
  let { state } = useLocation();
  const [addrss, setaddrss] = React.useState("");
  const [coinamount, setCoinAmount] = React.useState(0);
  let {
    transaction_type,
    recipient,
    amount,
    timestamp,
    confirmation,
    cointitle,
    id,
    seen,
  } = state;

  const handleChangeCoin = (value, key) =>
    Promise.resolve(usdToCoin(value, key));

  const handChangeAddress = async (key) => {
    switch (key) {
      case "BTC":
        return ad.btc;
      case "ETH":
        return ad.eth;
      case "BNB":
        return ad.bnb;
      case "TRX":
        return ad.tron;
      case "USDT TRC20":
        return ad.tron;
      default:
        return ad.eth;
    }
  };

  const isCredit = transaction_type === "Credit";
  const isPending = confirmation < 3;
  const isCompleted = isPending ? "Pending" : "Completed";
  const isrecipient = isCredit ? addrss : recipient;
  const timestampset = `${convertTimestamp(timestamp)} ${convertTimestampTime(
    timestamp
  )}`;
  React.useEffect(() => {
    console.log(ad);
    handChangeAddress(cointitle).then((address) => {
      setaddrss(address);
    });
    
    handleChangeCoin(amount, cointitle).then((coin) => {
      setCoinAmount(coin);
    });

    // mark as seen
    if (seen === null) return;
    const trxRef = doc(db, "users", userinfo.id, "transactions", id);
    setDoc(trxRef, { seen: true }, { merge: true }).then(() =>
      console.log("seen set")
    );
  }, [setaddrss, setCoinAmount]);

  return (
    <>
      <HeaderBackButton
        title={`${isCredit ? "Receive" : "Send"} ${cointitle}`}
      />
      <Container maxWidth="sm">
        <Stack spacing={4}>
          <Box display={"flex"} justifyContent={"center"}>
            <Stack spacing={1} alignItems={"center"}>
              <Typography level="title-lg" color="primary">
                + <CryptoCurrencyFormat amount={coinamount} suffix={""} />{" "}
                {cointitle}
              </Typography>
              <Typography level="body-sm">
                <CurrencyFormat amount={amount} prefix={"$"} seperator={true} />
              </Typography>
            </Stack>
          </Box>

          <List variant="outlined" sx={{ borderRadius: 10 }}>
            <ListItem>
              <ListItemContent>Status</ListItemContent>
              {isCredit ? (
                <Typography level="body-sm" color="success">
                  Completed
                </Typography>
              ) : (
                <Typography
                  level="body-sm"
                  color={isPending ? "warning" : "success"}
                >
                  {isCompleted}
                </Typography>
              )}
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Date</ListItemContent>
              <Typography level="title-sm">{timestampset}</Typography>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Recipient</ListItemContent>
              <Typography
                level="title-sm"
                textAlign={"right"}
                noWrap={true}
                width={"50%"}
              >
                {isrecipient}
              </Typography>
            </ListItem>
            <ListDivider />
            <ListItem>
              <ListItemContent>Confirmation</ListItemContent>
              <Typography
                level="title-sm"
                textAlign={"right"}
                noWrap={true}
                width={"50%"}
              >
                {isCredit ? 3 : confirmation} / 3
              </Typography>
            </ListItem>
          </List>
        </Stack>
      </Container>
    </>
  );
}
